<template>
  <b-row>
    <!-- Small -->

    <!-- Large -->
    <b-col cols="12">
      <b-form-group>
        <v-select
          :reduce="(val) => val.id"
          @search="filterText"
          v-model="selected"
          label="title"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="categories"
          class="select-size-lg"
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import axios from "@axios";
export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    vSelect,
  },
  created() {
    return new Promise((resolve, reject) => {
      const uri = `/lms/admin/course/getallcourses`;
      axios
        .get(uri)
        .then((response) => {
          const data = response.data.data;
          const responseData = JSON.parse(JSON.stringify(data));
          const filteredData = responseData.filter(
            (e) => e.courseStatus === 100
          );
          const options = filteredData.map((e) => {
            return { id: e.id, title: e.title, label: e.title };
          });
          console.log(options);
          options.unshift({ id: 0, title: "All", label: "All" });

          this.categories = options;
        })
        .catch((error) => reject(error));
    });
  },
  props: {
    initialCategories: [],
  },

  methods: {
    updateSelections(a) {
      //console.log(a)
    },
    filterText(search, loading) {
      if (loading) return [];
      return this.categories.filter((e) =>
        (e.title || "").toLowerCase().includes(search.toLowerCase())
      );
    },
  },
  watch: {
    selected: function (newVal, coldVal) {
      this.$emit("selectionChanged", newVal);
    },
  },
  data() {
    return {
      categories: [],
      options: [],
      selected: { id: 0, title: "All", label: "All" },
    };
  },
};
</script>
